import { defineComponent as _defineComponent } from 'vue'
import {
  BaseModal,
  ButtonIconContextual,
  HelperViewContextual
} from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalPaidCustodyCanceled',
  props: {
  showModal: Boolean
},
  emits: ['close'],
  setup(__props, { emit }) {

const { showModal } = __props;





const closeModal = () => {
  emit('close');
};

return { __sfc: true,emit, closeModal, BaseModal, ButtonIconContextual, HelperViewContextual }
}

})